import { render, staticRenderFns } from "./ArboCollections.vue?vue&type=template&id=0fbfa566&scoped=true&"
import script from "./ArboCollections.vue?vue&type=script&lang=js&"
export * from "./ArboCollections.vue?vue&type=script&lang=js&"
import style0 from "./ArboCollections.vue?vue&type=style&index=0&id=0fbfa566&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fbfa566",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/tmp/app/site2/src/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fbfa566')) {
      api.createRecord('0fbfa566', component.options)
    } else {
      api.reload('0fbfa566', component.options)
    }
    module.hot.accept("./ArboCollections.vue?vue&type=template&id=0fbfa566&scoped=true&", function () {
      api.rerender('0fbfa566', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Portefeuille/ArboCollections.vue"
export default component.exports